// extracted by mini-css-extract-plugin
export default {"picker":"ColorPicker_picker__ZO-jX","input":"ColorPicker_input__yxRWT"};